export function listUsers(send) {
  return (query, ...args) =>
    send(
      {
        path: '/v2/users',
        pathParameters: {},
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
